'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jsColors = require('./style/js-colors');

var _jsColors2 = _interopRequireDefault(_jsColors);

var _customEvent = require('custom-event');

var _customEvent2 = _interopRequireDefault(_customEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VSTUI = { colors: _jsColors2.default };
VSTUI.theme = {
  primary: VSTUI.colors.OCEAN,
  accent: VSTUI.colors.CHEDDAR,
  primaryKey: 'OCEAN',
  accentKey: 'CHEDDAR',
  get: function get(index) {
    return {
      primary: VSTUI.theme.getPrimary(index),
      accent: VSTUI.theme.getAccent(index)
    };
  },
  getPrimary: function getPrimary(index) {
    return VSTUI.theme.primary[index];
  },
  getAccent: function getAccent(index) {
    return VSTUI.theme.accent[index];
  }
};

VSTUI.changeTheme = function () {
  var primary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OCEAN';
  var accent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CHEDDAR';
  var customKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((typeof primary === 'undefined' ? 'undefined' : _typeof(primary)) === 'object' && customKey) {
    // this is a custom theme
    if (primary.length === 11) {
      VSTUI.theme.primary = primary;
      VSTUI.theme.accent = accent && accent.length === 11 ? accent : primary;
      VSTUI.theme.primaryKey = customKey + '_primary';
      VSTUI.theme.accentKey = customKey + '_accent';
    } else {
      console.error('Invalid custom theme! Must be 11 elements in length.');
    }
  } else {
    VSTUI.theme.primary = VSTUI.colors[primary];
    VSTUI.theme.accent = VSTUI.colors[accent];
    VSTUI.theme.primaryKey = primary;
    VSTUI.theme.accentKey = accent;
  }
  var event = new _customEvent2.default('_vstui_change_theme', {});
  document.dispatchEvent(event);
};

VSTUI.VSTUI = VSTUI;

module.exports = VSTUI;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/utils.js
 **/